module.exports = __webpack_public_path__ + "img/jingwaizhanhui.b3d69ce4.jpg";